import { useState, useEffect } from "react";

export default function IOSInstallPrompt() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Detect iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    // Detect if already installed (standalone)
    const isStandalone = window.navigator.standalone === true;

    if (isIOS && !isStandalone) {
      // Check if user dismissed it before
      const dismissed = localStorage.getItem("ios-install-dismissed");
      if (!dismissed) {
        setShow(true);
      }
    }
  }, []);

  if (!show) return null;

  return (
    <div 
      className="anim-in-up"
      style={{
        position: "fixed", bottom: 0, left: 0, right: 0,
        background: "#fff", borderTop: "3px solid #CC0000",
        padding: "24px 20px 32px 20px", zIndex: 9999,
        boxShadow: "0 -10px 40px rgba(0,0,0,0.15)",
        fontFamily: "'JetBrains Mono', monospace",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 16 }}>
        <div>
          <h3 style={{ margin: "0 0 6px 0", fontSize: "0.8rem", fontWeight: 700, color: "#111", letterSpacing: "0.05em" }}>INSTALL APPLICATION</h3>
          <p style={{ margin: 0, fontSize: "0.65rem", color: "#666", fontFamily: "Inter, sans-serif" }}>Get the native app experience on your iPhone/iPad.</p>
        </div>
        <button 
          onClick={() => {
            setShow(false);
            localStorage.setItem("ios-install-dismissed", "true");
          }}
          style={{ background: "transparent", border: "none", fontSize: "1.2rem", lineHeight: 1, cursor: "pointer", color: "#999", padding: "0 0 10px 10px" }}
        >
          ✕
        </button>
      </div>
      
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: "0.7rem", fontWeight: 700, color: "#CC0000" }}>01</span>
          <span style={{ fontSize: "0.7rem", color: "#111" }}>Tap the <b>Share</b> button in Safari</span>
          <svg width="20" height="24" viewBox="0 0 20 24" fill="none" style={{ marginLeft: "auto" }}>
            <path d="M10 1V15M10 1L5 6M10 1L15 6" stroke="#007AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 23H19V13H1V23Z" stroke="#007AFF" strokeWidth="2" strokeLinejoin="round"/>
          </svg>
        </div>
        <div style={{ width: "100%", height: 1, background: "#eee" }} />
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: "0.7rem", fontWeight: 700, color: "#CC0000" }}>02</span>
          <span style={{ fontSize: "0.7rem", color: "#111" }}>Scroll down & tap <b>Add to Home Screen</b></span>
          <div style={{ marginLeft: "auto", border: "1px solid #ccc", borderRadius: 4, padding: "2px 6px" }}>
            <span style={{ fontSize: "1rem", lineHeight: 1 }}>+</span>
          </div>
        </div>
      </div>
    </div>
  );
}
